import { SentryService } from '@/plugins/sentry/sentry';

export const createSentry = ({ config }) => ({ app, router }) => new SentryService({
  app,
  dsn: config.SENTRY.DSN,
  release: config.APP.APP_RELEASE,
  sampleRate: 1.0,
  attachStacktrace: true,
  logErrors: true,
  environment: config.SENTRY.ENV,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  tracesSampleRate: 1.0,
  router,
});
